// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3SqYl","header":"MessagesList_header__1k0O6","chat":"MessagesList_chat__ZSeP-"};